import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function AcceptedBy({ query, setQuery, editable = false }: Props) {
  const state = getAcceptedBy(query);
  const value = options.find((option) => option.value === state) ?? options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setAcceptedBy(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Accepted by"
      description="Filter by the source that accepted the quote on the application"
      disabled={!editable}
    />
  );
}

const options = [
  { label: 'All', value: undefined },
  { label: 'Customer (My Page)', value: 'MyPage' },
  { label: 'Auto Accept', value: 'AutoAccept' },
  { label: 'ACE', value: 'ACE' },
];

function setAcceptedBy(by: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    LoanQuoteAcceptedBy: by,
  });
}

function getAcceptedBy(query: ace_index.FindInput) {
  return query.LoanQuoteAcceptedBy;
}

type Value = ace_index.FindInput['LoanQuoteAcceptedBy'];
